import React, { useState } from 'react';
import { sendPasswordResetEmail } from 'firebase/auth';
import { auth, analytics } from '../../firebase';
import { logEvent } from 'firebase/analytics';
import { Link } from 'react-router-dom';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');

  const handleReset = async e => {
    e.preventDefault();
    setMessage('');
    setError('');

    const resetUrl =
      process.env.NODE_ENV === 'development'
        ? 'http://localhost:3000/login'
        : 'https://nccbrodriver.it/login';

    try {
      await sendPasswordResetEmail(auth, email, {
        url: resetUrl,
        handleCodeInApp: true,
      });

      logEvent(analytics, 'password_reset_requested', {
        email_domain: email.split('@')[1],
      });

      setMessage('Ti abbiamo inviato una mail per reimpostare la password.');
    } catch (err) {
      console.error(err);
      setError('Errore durante l’invio. Controlla l’email inserita.');
    }
  };

  return (
    <div className="flex min-h-full flex-col justify-center px-6 py-12 lg:px-8">
      <div className="sm:mx-auto sm:w-full sm:max-w-sm">
        <h2 className="mt-10 text-center text-2xl/9 font-bold tracking-tight text-gray-900">
          Recupera password
        </h2>
      </div>
      <div className="mt-10 sm:mx-auto sm:w-full sm:max-w-sm">
        {message && <p className="mb-3 text-sm text-green-600">{message}</p>}
        {error && <p className="mb-3 text-sm text-red-500">{error}</p>}

        <form onSubmit={handleReset} className="space-y-4">
          <div>
            <label htmlFor="email" className="block text-sm/6 font-medium text-gray-900">
              Email address
            </label>
            <div className="mt-2">
              <input
                id="email"
                name="email"
                type="email"
                value={email}
                onChange={e => setEmail(() => e.target.value)}
                required
                autoComplete="email"
                className="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-primary sm:text-sm/6"
              />
            </div>
          </div>
          <div>
            <button
              type="submit"
              className="w-full rounded bg-primary py-2 text-white hover:bg-primary"
            >
              Invia email di reset
            </button>
          </div>
        </form>

        <p className="mt-4 text-center text-sm text-gray-600">
          Torna al{' '}
          <Link to="/login" className="font-medium text-primary hover:underline">
            login
          </Link>
        </p>
      </div>
    </div>
  );
};

export default ForgotPassword;
